"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmsDiscovery = void 0;
const AuditLogsDiscovery_1 = require("./audit_logs/AuditLogsDiscovery");
const BlogsDiscovery_1 = require("./blogs/BlogsDiscovery");
const DomainsDiscovery_1 = require("./domains/DomainsDiscovery");
const HubdbDiscovery_1 = require("./hubdb/HubdbDiscovery");
const PerformanceDiscovery_1 = require("./performance/PerformanceDiscovery");
const SiteSearchDiscovery_1 = require("./site_search/SiteSearchDiscovery");
const SourceCodeDiscovery_1 = require("./source_code/SourceCodeDiscovery");
const UrlRedirectsDiscovery_1 = require("./url_redirects/UrlRedirectsDiscovery");
class CmsDiscovery {
    constructor(config = {}) {
        this.auditLogs = new AuditLogsDiscovery_1.AuditLogsDiscovery(config);
        this.blogs = new BlogsDiscovery_1.BlogsDiscovery(config);
        this.domains = new DomainsDiscovery_1.DomainsDiscovery(config);
        this.hubdb = new HubdbDiscovery_1.HubdbDiscovery(config);
        this.performance = new PerformanceDiscovery_1.PerformanceDiscovery(config);
        this.siteSearch = new SiteSearchDiscovery_1.SiteSearchDiscovery(config);
        this.sourceCode = new SourceCodeDiscovery_1.SourceCodeDiscovery(config);
        this.urlRedirects = new UrlRedirectsDiscovery_1.UrlRedirectsDiscovery(config);
    }
}
exports.CmsDiscovery = CmsDiscovery;
//# sourceMappingURL=CmsDiscovery.js.map